var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"steps"},[_c('div',{staticClass:"step-list"},_vm._l((_vm.stepItems),function(item,index){return _c('div',{key:index,class:['step-item', { active: index <= _vm.active }]},[_c('span',[_vm._v(_vm._s(item))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }